const DOCUMENT = 'EDIT_SHIFT_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  CANCEL: DOCUMENT + 'CANCEL',
  TOUCH: DOCUMENT + 'TOUCH',

  loadFormData: data => {
    return {
      type: actions.LOAD,
      payload: { ...data },
    };
  },

  loadFormDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  saveSuccess: data => ({
    type: actions.SAVE_SUCCESS,
    payload: data,
  }),

  saveError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),
};

export default actions;
